import App from './App'
import Home from './components/Home'
import Technician from './components/Technician'
import TicketError from './components/TicketError'
import TicketPending from './components/TicketPending'
import TicketSuccess from './components/TicketSuccess'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { store } from './store/store'
import firebase from 'firebase/app'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_KEY_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_KEY_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_ID
}

firebase.initializeApp(firebaseConfig);

Vue.use(VueRouter)
Vue.config.productionTip = false

// Routes
const router = new VueRouter ({
  mode : 'history',
  routes : [
  {path: '/', component: Home},
  {path: '/success', component: TicketSuccess},
  {path: '/error', component: TicketError, name: 'error'},
  {path: '/pending', component: TicketPending},
  {path: '/tech', component: Technician},
  ],
})

new Vue({
  store,
  router,
  render(h) { return h(App) }
}).$mount('#app')
